import {Component, OnInit, OnDestroy} from '@angular/core';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Formatters} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-priority-config',
  templateUrl: './priority-config.component.html',
  styleUrls: ['./priority-config.component.css']
})
export class PriorityConfigComponent implements OnInit, OnDestroy {

  displayed = true;
  prefix: string;
  dropdown: string;
  clientId: number;

  add = false;
  del = false;
  edit = false;
  view = false;

  displayData: any;

  isError = false;
  errorMessage: string;
  respObject: any;
  totalData: number;
  private notifier: NotifierService;
  type: string;
  tickets = [];
  private slideChecked = '1';
  slideCheckedValue: any ;
  ticketSelected: number;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private userAuth: Subscription;
  private baseFlag: any;
  offset: number;
  dataLoaded:boolean;
  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
              private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      // console.log(item);
      switch (item.type) {
        case 'change':
          // console.log('changed');
          if (!this.messageService.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {
            // if (confirm('Are you sure?')) {
            //   item.user_id = this.messageService.getUserId();
            //   this._rest.updateBusinessPriority(item).subscribe((res) => {
            //     this.respObject = res;
            //     if (this.respObject.success) {
            //       // console.log('data--Done');
            //       this.notifier.notify('success', 'Updated successfully');
            //     } else {
            //       // console.log('data--Not---Done');
            //       this.notifier.notify('error', this.respObject.errorMessage);
            //     }
            //   }, (err) => {
            //     this.notifier.notify('error', this.messageService.SERVER_ERROR);
            //   });
            // }
          }
          break;
        case 'delete':
          // console.log('deleted');
          if (!this.messageService.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              // console.log(JSON.stringify(item));
              // this._rest.deleteTicketPriorityConfiguration({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
              //   this.respObject = res;
              //   if (this.respObject.success) {
              //     this.totalData = this.totalData - 1;
              //     this.messageService.setTotalData(this.totalData);
              //     this.messageService.sendAfterDelete(item.id);
              //   } else {
              //     this.notifier.notify('error', this.respObject.errorMessage);
              //   }
              // }, (err) => {
              //   this.notifier.notify('error', this.messageService.SERVER_ERROR);
              // });
            }
          }
          break;
      }
    });
    // this.messageService.getUserAuth().subscribe(details => {
    //   console.log(JSON.stringify(details));
    //   if (details.length > 0) {
    //     this.add = details[0].addFlag;
    //     this.del = details[0].deleteFlag;
    //     this.view = details[0].viewFlag;
    //     this.edit = details[0].editFlag;
    //   } else {
    //     this.add = true;
    //     this.del = true;
    //     this.view = true;
    //     this.edit = true;
    //   }
    // });

  }


  ngOnInit() {
    this.dataLoaded=false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
      pageName: 'Maintain Priority Configuration',
      openModalButton: 'Add Priority Configuration',
      breadcrumb: 'PriorityConfiguration',
      folderName: 'All Priority Configuration',
      tabName: 'PriorityConfiguration'
    };
    // this.types = [{id: 1, name: 'text'}, {id: 2, name: 'numeric'}, {id: 3, name: 'dropdown'}];

    // this.typeSelected = 1;

    const columnDefinitions = [
      // {
      //   id: 'delete',
      //   field: 'id',
      //   excludeFromHeaderMenu: true,
      //   formatter: Formatters.deleteIcon,
      //   minWidth: 30,
      //   maxWidth: 30,
      // },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
      {
        id: 'ttype', name: 'Ticket Type', field: 'ticket_type_nm', sortable: true, filterable: true
      },
      {
        id: 'type', name: 'Type', field: 'ticket_priority_type', sortable: true, filterable: true
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
    }
  }

  onPageLoad() {
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.isError = false;
            this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
            this.tickets = this.respObject.details;
            this.ticketSelected = 0;
          } else {
            this.notifier.notify('error', this.respObject.errorMessage);
          }
        }, (err) => {
          this.notifier.notify('error', JSON.stringify(err));
        });
    this.getTableData();
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  openModal(content) {
    if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.slideChecked = '1';
      this.modalService.open(content, {size: 'sm'}).result.then((result) => {
      }, (reason) => {

      });
    }
  }

  save() {
    const data = {
      clientId: this.clientId,
      ticket_type: this.ticketSelected, ticket_priority_type: this.slideChecked,
      createdBy: this.messageService.getUserId()
    };
    // console.log(typeof this.typeSelected, this.typeSelected);

    if (!this.messageService.isBlankField(data)) {
      this._rest.insertTicketPriorityConfiguration(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.isError = false;
          // console.log(this.respObject)
          const id = this.respObject.details;
          this.messageService.setRow({
            id: id,
            ticket_type_nm: this.type,
            // category_id: this.category,
            // defaultValue: this.defaultValue,
            ticket_priority_type: this.slideCheckedValue
          });
          this.totalData = this.totalData + 1;
          this.messageService.setTotalData(this.totalData);
          if (this.totalData <= this.pageSize * this.page_no) {
              this.offset = id;
              this.nextOffset = 0;
          } else {
              this.nextOffset = this.offset;
          }
          this.prefix = '';
          this.dropdown = '';
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  getTableData() {
    if (!this.messageService.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
      this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded=false;
    this._rest.getTicketPriorityConfiguration(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      this.executeResponse(this.respObject, offset, paginationType);
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
          this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  onTicketChange(selectedIndex: any) {
    this.type = this.tickets[selectedIndex].name;
  }

  onPriorityButtonChange(selectedButton) {
    this.slideChecked = selectedButton.value;
     console.log(selectedButton.value);
      if (selectedButton.value === '1') {
          this.slideCheckedValue = 'Urgency Wise' ;
      } else {
          this.slideCheckedValue = 'Category Wise' ;
      }
  }

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
  }
}
